var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atoms/icon/title/learning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atoms/icon/title/learning",
    stroke: "#75593A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(2.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3.75,
    x2: 16,
    y2: 26.25,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.858993,2.37204796 L16.0005376,3.39557722 L16.0005376,3.39557722 L14.1411818,2.3717306 C11.3156808,0.815880141 8.14254398,-5.92522599e-16 4.91700118,0 L2,0 C0.8954305,2.02906125e-16 3.0881846e-16,0.8954305 0,2 L0,21.5572202 C-2.35872101e-14,22.6617897 0.8954305,23.5572202 2,23.5572202 L8.83400237,23.5572202 L8.83400237,23.5572202 C8.83400237,23.5572202 16.0166661,27.1828967 16.0188165,27.2689151 C16.0403211,26.9786029 23.1659976,23.5572202 23.1659976,23.5572202 L30,23.5572202 C31.1045695,23.5572202 32,22.6617897 32,21.5572202 L32,2 C32,0.8954305 31.1045695,-2.02906125e-16 30,0 L27.0829988,0 C23.8574715,5.92519747e-16 20.6843657,0.815996804 17.858993,2.37204796 Z",
    id: "Stroke-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningIcon);
export default __webpack_public_path__ + "static/media/learningIcon.72e9d6da77fb5c078b9a95377da34ff6.svg";
export { ForwardRef as ReactComponent };